<template>
  <mt-tab-container v-model="value">
    <!-- 每日精读训练营 -->
    <mt-tab-container-item :id="contentIndexs.activeIsCamp">
      <div class="nav" v-if="goodsInfo">
        <p class="title">
          <span class="line"></span>
          <span class="txt">会员权益</span>
          <span class="line"></span>
        </p>
        <div class="content">
          <dl>
            <dt>
              <img src="../../../images/goods/icon_wk.png" alt="" />
            </dt>
            <dd>
              <span>每日一篇</span>
              <span>精选外刊文章</span>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../../images/goods/icon_article.png" alt="" />
            </dt>
            <dd>
              <span>获取文章</span>
              <span>+复习课权限</span>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../../images/goods/icon_money.png" alt="" />
            </dt>
            <dd>
              <span>坚持学习</span>
              <span>全额退学费</span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="con">
        <div v-html="goodsInfo && goodsInfo.guideContent"></div>
      </div>
    </mt-tab-container-item>
    <!-- 每日精读年卡 -->
    <mt-tab-container-item :id="contentIndexs.activeIsForeignVip">
      <div class="nav">
        <p class="title">
          <span class="line"></span>
          <span class="txt">会员权益</span>
          <span class="line"></span>
        </p>
        <div class="content">
          <dl>
            <dt>
              <img src="../../../images/goods/icon_wk.png" alt="" />
            </dt>
            <dd>
              <span>有效期内更新保留</span>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../../images/goods/icon_article.png" alt="" />
            </dt>
            <dd>
              <span>专属学习社群</span>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../../images/goods/icon_teacher.png" alt="" />
            </dt>
            <dd>
              <span>支持外教朗读</span>
              <span>+名师讲解</span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="con">
        <div v-html="goodsInfo && goodsInfo.guideContent"></div>
      </div>
    </mt-tab-container-item>
    <!-- 无限卡会员 -->
    <mt-tab-container-item :id="contentIndexs.activeIsForeverVip">
      <div class="nav">
        <p class="title">
          <span class="line"></span>
          <span class="txt">会员权益</span>
          <span class="line"></span>
        </p>
        <div class="content">
          <dl>
            <dt>
              <img src="../../../images/goods/icon_course.png" alt="" />
            </dt>
            <dd>
              <span>无限畅听</span>
              <span>APP内所有课程</span>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../../images/goods/icon_listen.png" alt="" />
            </dt>
            <dd>
              <span>永久保留</span>
              <span>无限回放</span>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../../images/goods/icon_talk.png" alt="" />
            </dt>
            <dd>
              <span>专享英语界</span>
              <span>大咖访谈</span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="con">
        <div v-html="goodsInfo && goodsInfo.guideContent"></div>
      </div>
    </mt-tab-container-item>
  </mt-tab-container>
</template>

<script>
export default {
  name: 'vip-goods-content',
  props: {
    options: {
      type: Object,
      default: () => {}
    },
    value: {
      type: [Number, String],
      default: () => ''
    }
  },
  computed: {
    hasGoods() {
      return this.options && this.options.hasGoods;
    },
    goodsInfo() {
      return this.options && this.options.goodsInfo;
    },
    contentIndexs() {
      return this.options && this.options.contentIndexs;
    }
  }
};
</script>

<style lang="less" scoped>
.goods-page {
  .mint-tab-container {
    padding-bottom: 1.68rem;
  }
  .con {
    padding: 0 .48rem;
    color: #fff;
    min-height: 10rem; // 全面屏手机尺寸占位
    img {
      width: 100%;
      height: auto;
    }
  }
  .nav {
    padding: 0.64rem 0.48rem 0.8rem;
    display: flex;
    flex-direction: column;
    color: #FFD17F;
    font-size: 0.36rem;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      .line {
        width: 0.32rem;
        height: 0.04rem;
        background: linear-gradient(
          180deg,
          rgba(255, 218, 152, 1) 0%,
          rgba(226, 161, 66, 1) 100%
        );
      }
      .txt {
        padding: 0 0.24rem;
      }
    }
    .content {
      width: 100%;
      margin-top: 0.64rem;
      display: flex;
      justify-content: space-between;
      dl {
        flex: 1;
        dt {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 1.2rem;
            height: 1.2rem;
          }
        }
        dd {
          margin-top: 0.42rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 0.24rem;
          line-height: 0.33rem;
        }
      }
    }
  }
}
</style>